export default __webpack_public_path__ + "static/media/doctorate-glyph-16px.56301635.svg";